import script from "./VATable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VATable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__